<template>
  <div class="container-fluid header">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-md-12 text-center"> 
            <a href="https://elfoco.pe/" target="_blank">
              <img class="brand-logo" src="https://elfoco.pe/wp-content/uploads/2021/01/cropped-LOGOS-ELFOCO-white-1.png" alt="El Foco" />
            </a>
          </div>
          
        </div>
      </div>
    </div>

  </div>
</template>

<script>


export default {
  name: 'NavBar'
}
</script>
